import "tabler-react/dist/Tabler.css";
import "tabler-react/dist/Tabler.css";
import { Site, Dimmer } from "tabler-react";
import React, { Component } from "react";
import Header from "./Header";
import Actividades from "./actividades/Actividades";
import General from "./general/General";
import IngresoPlataformas from "./ingresoPlataformas/IngresoPlataformas";
import MisCursos from "./misCursos/MisCursos";
import PerfilAlumno from "./perfilAlumno/PerfilAlumno";
import RiesgoAlumno from "./riesgoAlumno/RiesgoAlumno";

/**
 * Clase inicio para obtener los datos principales del usuario logueado (se movieron las validaciones)
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 2.0 30/06/2021
 */
class Inicio extends Component {
	constructor(props) {
		super(props);
		this.state = {
			ruta: this.props.ruta,
			profile: this.props.profile,
			isLoading: true,
		}
	}

	Componente = () => {
		let componenteElegido = <General profile={this.state.profile}/>
		switch(this.state.ruta) {
			case '/':
				componenteElegido = <General profile={this.state.profile}/>;
				break;
			case "mis-cursos":
				componenteElegido = <MisCursos profile={this.state.profile}/>;
				break;
			case "actividades":
				componenteElegido = <Actividades profile={this.state.profile}/>;
				break;
			case "perfil-del-alumno":
				componenteElegido = <PerfilAlumno profile={this.state.profile}/>;
				break;
			case "riesgo-del-alumno":
				componenteElegido = <RiesgoAlumno profile={this.state.profile}/>;
				break;
			case "ingresar-a-plataformas":
				componenteElegido = <IngresoPlataformas profile={this.state.profile}/>;
				break;
			default:
				componenteElegido = <General profile={this.state.profile}/>;
				break;

		}
		return componenteElegido;
	}

	componentDidMount = () => {
		this.setState({isLoading: false});
	}

	render() {
		// Verifica si el loading sigue activo
		if (this.state.isLoading) {
			return (
				<Site>
					<Dimmer loader active />
				</Site>
			);
		} else {
			return (
				<>
					<Header profile={this.state.profile}/>
					<this.Componente />
				</>
			);
		}
	}
}

export default Inicio;